<script setup lang="ts">
import ArticleIcon from '~/assets/icons/ArticleSmall.svg'
import NavigationLink from '~/components/shared/navigation/Link.vue'

const props = withDefaults(
  defineProps<{
    backgroundImage: string
    publishedDate: string
    readingTime?: string | number
    title: string
    url: string
  }>(),
  {
    readingTime: '',
  },
)
</script>

<template>
  <NavigationLink
    data-testid="source-article-card"
    class="card-hover-md flex rounded-xl cursor-pointer flex-col items-start gap-x-5 gap-y-1.5 mb-4 last:pb-0 md:flex-row"
    :url="props.url ?? ''"
    type="a"
  >
    <div
      data-testid="article-card-image"
      class="relative rounded-t-xl md:rounded-t-none md:!rounded-l-xl h-44 w-full shrink-0 bg-cover bg-center md:h-full md:w-48"
      :style="{
        backgroundImage: `url('${props.backgroundImage}')`,
      }"
    >
      <div
        class="absolute right-3 top-3 hidden h-6 w-6 items-center justify-center rounded-full bg-white p-1 md:flex"
      >
        <ArticleIcon class="size-3.5" />
      </div>
    </div>
    <div class="flex flex-col gap-y-2 md:pr-5 py-3">
      <div
        class="flex items-center gap-x-1.5 text-xs font-semibold text-[#A3A5AE] md:font-normal"
      >
        <div
          class="ml-0.5 flex size-7 items-center justify-center rounded-full border md:hidden"
        >
          <ArticleIcon class="size-3.5" />
        </div>
        <div class="flex flex-col">
          <span data-testid="article-card-type">Article</span>
          <span data-testid="article-card-published-date">
            {{ props?.publishedDate }}
            {{ props?.readingTime ? `| ${props.readingTime} min read` : '' }}
          </span>
        </div>
      </div>
      <p
        data-testid="article-card-title"
        class="line-clamp-2 text-base font-bold leading-6 md:text-h4"
      >
        {{ props.title }}
      </p>
    </div>
  </NavigationLink>
</template>

<style scoped>
@media (min-width: 1024px) {
  .card-hover-md {
    @apply cursor-pointer transition-shadow duration-500;
  }

  .card-hover-md:hover {
    @apply shadow-card-hover scale-[1.008] hover:z-10;
  }
}
</style>
